import { localize } from 'mixins/helpers';
import React from 'react';
import SearchIcon from './search-icon.svg';
import './search.scss';

interface Props {
    label: string;
    onSubmit?: (event: React.FormEvent<HTMLFormElement>) => void;
    onChange?: any;
    translations: any;
}

const Search = ({ label, onSubmit, onChange, translations }: Props) => {
    const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();
        if (onSubmit) {
            onSubmit(event);
        }
    };
    return (
        <div className="search-wrapper">
            <h1 className="search-label">{label}</h1>
            <div className="search-input-wrapper">
                <form
                    onSubmit={handleSubmit}
                    className="search-form"
                >
                    <div className="search-icon-wrapper">
                        <SearchIcon className="search-icon" />
                    </div>
                    <input
                        placeholder={localize('what-going-to-look-for', translations)}
                        className="search-input"
                        onChange={onChange}
                    />
                </form>
            </div>
        </div>
    );
};

export default Search;
